// this is generated via google sheet json export
export default {
  seoTitle: "NFL Picks and DAILY NFL Predictions",
  news: {
    seoTitle: "NFL Sports Betting News | BetQL",
  },
  description:
    "Top site for weekly NFL picks. Check out the latest NFL Predictions and NFL prop picks for the week. We make betting on the NFL a snap.",
  "free-pick-predictions": {
    seoTitle: "Free NFL Picks | NFL Predictions | BetQL",
    h1: "BetQL Free NFL Picks",
  },
  "best-bets": {
    seoTitle: "NFL Spreads | NFL Odds | BetQL",
    h1: "NFL Trending Bets",
    description:
      "Check out BetQL for the latest NFL odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
  },
  odds: {
    seoTitle: "NFL Point Spreads | NFL Lines | NFL Odds",
    h1: "NFL Model Bets for Today",
    description:
      "Check out BetQL for the latest NFL point spreads, odds, lines, and spreads. Get the most updated odds, expert picks, and consensus picks from BetQL.",
    "first-half-moneyline": {
      seoTitle: "NFL First Half Moneyline Odds | BetQL",
      h1: "NFL 1st Half Money Line Model Bets",
      description:
        "Check out BetQL for the latest NFL first half money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-lines": {
      seoTitle: "NFL First Half Lines | NFL First Half Odds | BetQL",
      h1: "NFL 1st Half Model Bets",
      description:
        "Check out BetQL for the latest NFL first half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NFL Money Lines | NFL Money Line Odds | BetQL",
      h1: "NFL Money Line Model Bets",
      description:
        "Check out BetQL for the latest NFL money line odds. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneylines": {
      seoTitle: "NFL Second Half Money Lines | BetQL",
      h1: "NFL 2nd Half Money Line Model Bets",
      description:
        "Check out BetQL for the latest NFL 2nd half money lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NFL Over Unders | NFL Over Under Picks | BetQL",
      h1: "NFL Over Under Picks",
      description:
        "Check out BetQL for the latest NFL over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-totals-spread": {
      seoTitle: "NFL First Half Over Under Lines | BetQL",
      h1: "NFL 1st Half Over Under Model Bets",
      description:
        "Check out BetQL for the latest NFL first half over under lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-lines": {
      seoTitle: "NFL Second Half Lines | NFL 2nd Half Odds | BetQL",
      h1: "NFL 2nd Half Model Bets",
      description:
        "Check out BetQL for the latest NFL 2nd half lines. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "public-betting": {
    seoTitle: "NFL Consensus Picks | NFL Public Betting | BetQL",
    h1: "NFL Public Betting Consensus Picks",
    description:
      "Check out BetQL for the latest NFL public betting percentages. Get the most updated odds, lines, spreads, and consensus picks from BetQL.",
    "first-half-lines": {
      seoTitle: "NFL Public First Half Picks | BetQL",
      h1: "NFL 1st Half Public Betting",
      description:
        "Check out BetQL for the latest NFL 1st half consensus picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "NFL Public First Half Money Line Picks | BetQL",
      h1: "NFL 1st Half Money Line Public Picks",
      description:
        "Check out BetQL for the latest NFL 1st half money line public picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-totals-spread": {
      seoTitle: "NFL Public Betting 1st Half Total | BetQL",
      h1: "NFL 1st Half Over Under Public Picks",
      description:
        "Check out BetQL for the latest NFL 1st half over under public picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NFL Public Money Line | NFL Public Money Line Betting | BetQL",
      h1: "NFL Money Line Public Betting Consensus Picks",
      description:
        "Check out BetQL for the latest NFL money line public picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-lines": {
      seoTitle: "NFL Public 2nd Half Picks |BetQL",
      h1: "NFL 2nd Half Public Betting",
      description:
        "Check out BetQL for the latest NFL 2nd half public picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneylines": {
      seoTitle: "NFL Public 2nd Half Money Line Picks | BetQL",
      h1: "NFL 2nd Half Money Line Public Picks",
      description:
        "Check out BetQL for the latest NFL 2nd half money line public picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NFL Public Over Unders | NFL Public Over Under Picks | BetQL",
      h1: "NFL Over Under Public Betting",
      description:
        "Check out BetQL for the latest NFL over under public picks. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "sharp-picks": {
    seoTitle: "NFL Picks | NFL Expert Picks | BetQL",
    h1: "NFL Picks Against the Spread",
    description:
      "Check out BetQL for the latest NFL picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "NFL 1st Half Expert Picks | BetQL",
      h1: "NFL 1st Half Picks Against the Spread",
      description:
        "Check out BetQL for the latest NFL first half picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "NFL 1st Half Money Line Expert Picks | BetQL",
      h1: "NFL 1st Half Money Line Picks",
      description:
        "Check out BetQL for the latest NFL first half money line picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-totals-spread": {
      seoTitle: "NFL 1st Half Over Under Expert Picks | BetQL",
      h1: "NFL 1st Half Over Under Expert Picks",
      description:
        "Check out BetQL for the latest NFL first half over under picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NFL Money Line Expert Picks | BetQL",
      h1: "NFL Money Line Picks",
      description:
        "Check out BetQL for the latest NFL money line picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-lines": {
      seoTitle: "NFL 2nd Half Expert Picks | BetQL",
      h1: "NFL 2nd Half Picks Against the Spread",
      description:
        "Check out BetQL for the latest NFL 2nd half picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneylines": {
      seoTitle: "NFL 2nd Half Money Line Expert Picks | BetQL",
      h1: "NFL 2nd Half Money Line Picks",
      description:
        "Check out BetQL for the latest NFL 2nd half money line picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NFL Over Under Expert Picks | BetQL",
      h1: "NFL Over Under Picks",
      description:
        "Check out BetQL for the latest NFL over under picks from our expert model. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
  "line-movement": {
    seoTitle: "NFL Line Movement | NFL Betting Line Movement | BetQL",
    h1: "NFL Line Movement",
    description:
      "Check out BetQL for the latest NFL line movement and use our NFL line movement tracker to find the best time to bet. Get the most updated odds, lines, spreads, and picks from BetQL.",
    "first-half-lines": {
      seoTitle: "NFL First Half Line Movement | BetQL",
      h1: "NFL 1st Half Line Movement",
      description:
        "Check out BetQL for the latest NFL first half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-moneyline": {
      seoTitle: "NFL First Half Moneyline Movement | BetQL",
      h1: "NFL 1st Half Money Line Movement",
      description:
        "Check out BetQL for the latest NFL first half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "first-half-totals-spread": {
      seoTitle: "NFL Over Under Line Movement | BetQL",
      h1: "NFL 1st Half Over Under Line Movement",
      description:
        "Check out BetQL for the latest NFL first half over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    moneyline: {
      seoTitle: "NFL Money Line Movement | BetQL",
      h1: "NFL Money Line Movement",
      description:
        "Check out BetQL for the latest NFL money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-lines": {
      seoTitle: "NFL 2nd Half Line Movement | NFL Second Half Line Movement | BetQL",
      h1: "NFL 2nd Half Line Movement",
      description:
        "Check out BetQL for the latest NFL 2nd half line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "second-half-moneylines": {
      seoTitle: "NFL 2nd Half Moneyline Movement | BetQL",
      h1: "NFL 2nd Half Money Line Movement",
      description:
        "Check out BetQL for the latest NFL 2nd half money line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
    "totals-spread": {
      seoTitle: "NFL Over Under Line Movement | BetQL",
      h1: "NFL Over Under Line Movement",
      description:
        "Check out BetQL for the latest NFL over under line movement. Get the most updated odds, lines, spreads, and picks from BetQL.",
    },
  },
};
